import { createContext, useContext } from "react";
import type { MeQuery } from "~/graphql/generated";

export type OrgMembership = NonNullable<NonNullable<MeQuery["me"]>["memberships"]>[number];

export interface OrgContextValue {
  /** The current user's active organisation ID (bowfast UUID). */
  orgId: string;
  /** Full membership record for the active org. */
  membership: OrgMembership | null;
  /** Current user from the me query. */
  me: NonNullable<MeQuery["me"]> | null;
}

export const OrgContext = createContext<OrgContextValue>({
  orgId: "",
  membership: null,
  me: null,
});

/**
 * Returns the resolved org context for the authenticated user.
 * Must be used within the authenticated layout (below OrgContext.Provider).
 */
export function useOrg(): OrgContextValue {
  return useContext(OrgContext);
}
